// common thesis category definitions
import thesis_categories from "../resources/categories.json";

// criteria data in different languages
import fi from '../resources/data_fi.json';
import en from '../resources/data_en.json'

const criteria_data = { fi, en };

export { thesis_categories, criteria_data };

